/* Santas Vault - sack and stocking sets (store 0.31.0, 24 Sep 2026).
   ------------------------------------------------------------------
   A set is the sack and the stocking of one design with one name, added as two line items so each keeps its own
   print file and tracking. The price is the multi-buy tiers doing their job (2 items 10%, 3 or 4 items 15%, 5 or
   more 20%); nothing here discounts anything, it only shows what the cart will do and adds the lines.

   Product page (sack or stocking): a tick box "add the matching ... for each name". sv-multi.js owns the add and
   calls window.SVSet.expand(lines) just before it posts, which returns the lines with a partner line after each.
   Builder shelf: an "Add the set" button beside Add to cart, reading the builder's own state through
   root.svSetState() and redrawn on its sv:state event.
   See snippets/sv-set.liquid for the rules and the tiers. */
(function () {
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function money(c) { return '$' + (c / 100).toFixed(2); }
  function tiersOf(el) {
    return (el.getAttribute('data-tiers') || '').split(',').map(function (t) {
      var p = t.split(':'); return [parseInt(p[0], 10), parseInt(p[1], 10)];
    }).filter(function (t) { return t[0] > 0; }).sort(function (a, b) { return a[0] - b[0]; });
  }
  function pctFor(tiers, items) {
    var p = 0; tiers.forEach(function (t) { if (items >= t[0]) p = t[1]; }); return p;
  }
  function nextTier(tiers, items) {
    for (var i = 0; i < tiers.length; i++) if (tiers[i][0] > items) return tiers[i];
    return null;
  }
  // The checkout allocates a percentage per line and rounds half up, so the cart shows $146.62 for a $162.90 set.
  function line(c, pct) { return Math.round(c * (100 - pct) / 100); }
  function propsFor(src) {
    var p = {};
    if (src && src['Name']) {
      p['Name'] = src['Name'];
      if (src['Lettering']) p['Lettering'] = src['Lettering'];
      if (src['Lettering colour']) p['Lettering colour'] = src['Lettering colour'];
    }
    return p;
  }

  /* ------------------------------------------------------------ product page */
  function product(box) {
    var on = $('[data-set-on]', box), sum = $('[data-set-sum]', box), err = $('[data-set-err]', box);
    var tiers = tiersOf(box), maxc = parseInt(box.getAttribute('data-maxc'), 10) || 10;
    var selfC = parseInt(box.getAttribute('data-self-price'), 10), partC = parseInt(box.getAttribute('data-partner-price'), 10);
    var partId = box.getAttribute('data-partner-id');
    var selfL = box.getAttribute('data-self'), partL = box.getAttribute('data-partner');

    function count() { return Math.max(1, $$('.sv-perso .sv-item').length); }
    function names() { return $$('.sv-perso .sv-name'); }
    function tooLong() { return names().filter(function (i) { return (i.value || '').trim().length > maxc; }); }
    function limit() {
      names().forEach(function (i) {
        if (!i.hasAttribute('data-set-max')) i.setAttribute('data-set-max', i.getAttribute('maxlength') || '');
        if (on.checked) i.setAttribute('maxlength', String(maxc));
        else if (i.getAttribute('data-set-max')) i.setAttribute('maxlength', i.getAttribute('data-set-max'));
      });
    }
    function draw() {
      limit();
      var bad = on.checked ? tooLong() : [];
      err.hidden = !bad.length;
      if (bad.length) err.textContent = 'A stocking fits ' + maxc + ' characters, so a set name can be up to ' + maxc +
        '. Shorten "' + bad[0].value.trim() + '" or untick the set.';
      if (!on.checked) { sum.hidden = true; return; }
      var n = count(), items = 2 * n, pct = pctFor(tiers, items);
      var total = n * (line(selfC, pct) + line(partC, pct)), list = n * (selfC + partC);
      var nx = nextTier(tiers, items);
      sum.hidden = false;
      sum.innerHTML = '<b>' + n + (n === 1 ? ' set' : ' sets') + ': ' + money(total) + ' delivered</b><br>' +
        n + ' ' + selfL + (n === 1 ? '' : 's') + ' and ' + n + ' ' + partL + (n === 1 ? '' : 's') + ', ' + items + ' items at ' + pct +
        '% off. You save ' + money(list - total) + '.' +
        (nx ? ' One more set takes ' + pctFor(tiers, items + 2) + '% off everything.' : '') +
        ' Choose how many above and give each one its name.';
    }
    on.addEventListener('change', draw);
    document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('.sv-qty__b')) setTimeout(draw, 80); });
    document.addEventListener('input', function (e) { if (e.target.matches && e.target.matches('.sv-perso .sv-name')) draw(); });

    // Called by sv-multi.js before it posts. Returns {lines} or {error}.
    window.SVSet = {
      expand: function (lines) {
        if (!on.checked) return { lines: lines };
        if (tooLong().length) { draw(); err.scrollIntoView({ block: 'center', behavior: 'smooth' }); return { error: err.textContent }; }
        var out = [];
        lines.forEach(function (l) {
          out.push(l);
          out.push({ id: partId, quantity: l.quantity || 1, properties: propsFor(l.properties) });
        });
        return { lines: out };
      }
    };
    draw();
  }

  /* ------------------------------------------------------------ builder */
  function builder(box) {
    var root = box.closest('[data-sv-build]');
    if (!root) return;
    var btn = $('[data-set-add]', box), err = $('[data-set-err]', box), title = $('[data-set-title]', box);
    var desc = $('[data-set-d]', box), page = $('[data-set-page]', box);
    var tiers = tiersOf(box), maxc = parseInt(box.getAttribute('data-maxc'), 10) || 10;
    var cache = {}, cur = null, seq = 0;

    function fetchProduct(h) {
      if (cache[h]) return Promise.resolve(cache[h]);
      return fetch('/products/' + h + '.js').then(function (r) { if (!r.ok) throw 0; return r.json(); })
        .then(function (j) { cache[h] = j; return j; });
    }
    function update() {
      var s = root.svSetState && root.svSetState();
      if (!s || (s.kind !== 's' && s.kind !== 'c') || !s.design || !s.variant || !s.sfx) { box.hidden = true; cur = null; return; }
      var pk = s.kind === 's' ? 'c' : 's';
      if ((s.design[4] || '').indexOf(pk) < 0) { box.hidden = true; cur = null; return; }
      var d = s.design, ph = (d[6] && d[6][pk]) || (d[5] + (s.sfx[pk] || ''));
      var my = ++seq;
      fetchProduct(ph).then(function (j) {
        if (my !== seq) return;
        var pv = (j.variants || []).filter(function (v) { return v.available; })[0];
        if (!pv || !s.variant.available) { box.hidden = true; cur = null; return; }
        var pct = pctFor(tiers, 2), selfC = s.variant.price, partC = pv.price;
        var total = line(selfC, pct) + line(partC, pct);
        var selfL = s.kind === 's' ? 'sack' : 'stocking', partL = s.kind === 's' ? 'stocking' : 'sack';
        cur = { s: s, pv: pv };
        title.textContent = 'Make it a set: the matching ' + partL;
        desc.innerHTML = 'The same artwork' + (s.name ? ' and ' + s.name.replace(/[<>&"]/g, '') : ' and name') + ' on the ' + partL +
          '. ' + selfL.charAt(0).toUpperCase() + selfL.slice(1) + ' and ' + partL + ' <b>' + money(total) + '</b> delivered instead of ' +
          money(selfC + partC) + '.';
        btn.textContent = 'Add the set, ' + money(total);
        if (page) page.href = '/products/' + s.handle;
        var long = (s.name || '').length > maxc;
        err.hidden = !long;
        if (long) err.textContent = 'A stocking fits ' + maxc + ' characters. Shorten the name to add the set.';
        btn.disabled = long;
        box.hidden = false;
      }).catch(function () { if (my === seq) { box.hidden = true; cur = null; } });
    }
    root.addEventListener('sv:state', update);
    var nm = $('#sv-bd-name', root);
    if (nm) nm.addEventListener('input', function () { clearTimeout(nm._svt); nm._svt = setTimeout(update, 150); });
    root.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.sv-bd__face, .sv-bd__ink')) setTimeout(update, 30);
    });
    btn.addEventListener('click', function () {
      if (!cur) return;
      var s = root.svSetState(), props = {};
      if (s.name) {
        if (s.name.length > maxc) return update();
        props['Name'] = s.name;
        if (s.face) props['Lettering'] = s.face;
        if (s.ink && s.ink !== 'Design') props['Lettering colour'] = s.ink;
      }
      btn.disabled = true; btn.textContent = 'Adding the set…';
      var items = [{ id: s.variant.id, quantity: 1, properties: props }, { id: cur.pv.id, quantity: 1, properties: props }];
      var label = (s.name || 'No name') + ', ' + (s.design ? s.design[1] : '') + ' sack and stocking';
      // 0.36.0: stay on the shelf after a set so the next child's set can have its own design and name.
      var go = root.svAddLines ? root.svAddLines(items, label) :
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
          .then(function (r) { if (!r.ok) throw new Error('failed'); setTimeout(function () { window.location.href = '/cart'; }, 700); });
      go.then(function () { btn.disabled = false; update(); })
        .catch(function (e) {
          btn.disabled = false; update();
          err.hidden = false; err.textContent = 'The set could not be added: ' + String(e.message || e).slice(0, 90);
        });
    });
    update();
  }

  function start() {
    $$('[data-sv-set]').forEach(function (box) {
      if (box.dataset.svOn) return;
      box.dataset.svOn = '1';
      if (box.getAttribute('data-where') === 'product') product(box); else builder(box);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
